/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_EditInputs */

const en_pc_cmp_r_edit = /** @type {(inputs: Pc_Cmp_R_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit existing text and images`)
};

const zh_pc_cmp_r_edit = /** @type {(inputs: Pc_Cmp_R_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑已有文字与图片`)
};

/**
* | output |
* | --- |
* | "Edit existing text and images" |
*
* @param {Pc_Cmp_R_EditInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_edit = /** @type {((inputs?: Pc_Cmp_R_EditInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_EditInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_edit(inputs)
	return zh_pc_cmp_r_edit(inputs)
});
export { pc_cmp_r_edit as "pc.cmp.r.edit" }